module.exports = __webpack_public_path__ + "fonts/KrungthaiFastWeb-Regular.badab2c8.ttf";